<template>
  <div class="left-center-list">
    <div style="position: relative">
      <titleComponent titleName="事项分布"> </titleComponent>
      <el-radio-group
        v-model="tabPosition"
        style="margin-bottom: 30px"
        class="special-radio"
        size="mini"
        @input="tabChangeRadio"
      >
        <el-radio-button label="top">长期巡查</el-radio-button>
        <el-radio-button label="bottom">孤寡老人巡查</el-radio-button>
      </el-radio-group>
    </div>
    <div v-if="tabPosition == 'top'" class="flex-just">
      <div class="center-point">
        <titleInternal titleName="任务类型分布"></titleInternal>
        <div style="width: 518px; height: 340px">
          <wgEchart :options="leftCenterOneList" id="leftCenterOne"></wgEchart>
        </div>
      </div>
      <div class="center-point">
        <titleInternal titleName="今日巡查问题分布"></titleInternal>
        <div style="width: 518px; height: 340px">
          <wgEchart :options="leftCenterTwoList" id="leftCenterTwo"></wgEchart>
        </div>
      </div>
      <div class="center-point center-pointOne">
        <titleInternal titleName="事项处办分析"></titleInternal>
        <div style="width: 410px; height: 320px" v-if="leftCenterThreeList.length">
          <pieTu :optionData="leftCenterThreeList" :totalAge="totalAge"></pieTu>
        </div>
      </div>
    </div>
    <div v-if="tabPosition == 'bottom'" class="flex-just">
      <div class="center-point">
        <titleInternal titleName="年龄分布"></titleInternal>
        <div style="width: 518px; height: 340px">
          <wgEchart :options="leftCenterFiveList" id="leftCenterThree"></wgEchart>
        </div>
      </div>
      <div class="center-point center-pointFour">
        <titleInternal titleName="社区年龄分布"></titleInternal>
        <div style="width: 948px; height: 340px">
          <wgEchart :options="leftCenterFourList" id="leftCenterFour"></wgEchart>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import wgEchart from "@/components/wgEchart/wgEchart.vue";
import titleInternal from "@/pages/patrolScreen/components/title-internal.vue";
import titleComponent from "@/pages/patrolScreen/components/title.vue";
import pieTu from "@/pages/patrolScreen/components/left/pieTu.vue";
import * as echarts from "echarts";
import { getEventTaskLongPatrol, getEventTaskOldPeople } from "@/api/daping.js";
export default {
  name: "index",
  components: {
    wgEchart,
    titleInternal,
    titleComponent,
    pieTu,
  },
  data() {
    return {
      tabPosition: "top",
      leftCenterOneList: {},
      leftCenterTwoList: {},
      leftCenterThreeList: [],
      leftCenterFiveList: {},
      leftCenterFourList: {},
      totalAge: 0
    };
  },
  mounted() {
    this.getEventTaskLongPatrol(1);
    this.getEventTaskLongPatrol(2);
    this.getEventTaskLongPatrol(3);
  },
  methods: {
    async getEventTaskLongPatrol(type) {
      let res = await getEventTaskLongPatrol({
        type: type,
      });
      if (res.data.code == 200) {
        if (type == 1) {
          this.optionsListData(res.data.data && res.data.data.eventManageTypeList);
        } else if (type == 2) {
          this.optionsListDataTwo(res.data.data && res.data.data.eventQuetionsList);
        } else {
          this.optionsListDataFive(res.data.data && res.data.data.chubanFenxiList);
        }
      }
    },
    async getEventTaskOldPeople() {
      let res = await getEventTaskOldPeople();
      if (res.data.code == 200) {
        console.log(res.data.data.ageFenbu, 999)
        this.optionsListDataThree(res.data.data && res.data.data.ageFenbu)
        this.optionsListDataFour(res.data.data && res.data.data.communityRestList)
      }
    },
    optionsListData(dataList) {
      let dateArr = dataList.map((item) => item.typeName);
      let wzArr = dataList.map((item) => item.communityCount);
      let gzhArr = dataList.map((item) => item.blockCount);
      let option = {
        grid: {
          left: "20%",
          right: "5%",
          top: "12%",
          bottom: "8%",
        },
        legend: {
          show: true,
          itemWidth: 14,
          itemHeight: 6,
          // itemGap:50,
          right: 10,
          textStyle: {
            color: "#E4F2FF",
            fontSize: 16,
          },
        },
        tooltip: {
          // show: true,
          // trigger: "item",
          // formatter: "{b}: {c}",
          backgroundColor: "rgba(3,9,24,0.7)",
          borderColor: "rgba(3,9,24,0.7)",
          textStyle: {
            color: "#fff",
          },
          trigger: "axis",
          axisPointer: {
            type: "shadow",
          },
          formatter: function (param) {
            let res = param[0].name + "<br>";
            for (let j = 0; j < param.length; j++) {
              // 渐变色导致提示框中颜色消失,额外定义
              let marker = `<span style="display:inline-block;margin-right:5px;border-radius:50%;width:10px;height:10px;background-color:${param[j].color.colorStops[1].color};"></span>`;
              res += marker + param[j].seriesName + ": " + param[j].value + "<br>";
            }
            return res;
          },
        },
        xAxis: {
          type: "value",
          // "max": max,
          splitLine: {
            show: true,
            lineStyle: {
              color: "rgba(172, 206, 234, 0.2)",
              type: "dashed",
            },
          },
          axisLine: {
            show: false,
          },
          axisLabel: {
            show: true,
            textStyle: {
              color: "#ADC2D3",
              fontSize: 16,
            },
          },
          axisTick: {
            show: false,
          },
        },
        yAxis: [
          {
            type: "category",
            inverse: true,
            data: dateArr,
            axisLine: {
              show: false,
            },
            axisTick: {
              show: false,
            },
            axisLabel: {
              // "margin": 10,
              textStyle: {
                color: "#ADC2D3",
                fontSize: 15,
              },
              //多出字可以省略显示成点
              formatter: function (params) {
                var index = 5; //字数为6个超出就显示成点
                var newstr = "";
                for (var i = 0; i < params.length; i += index) {
                  var tmp = params.substring(i, i + index);
                  newstr += tmp + "";
                }
                if (newstr.length > 5) return newstr.substring(0, 5) + "...";
                else return newstr;
              },
            },
          },
        ],
        dataZoom: [
          {
            // 设置滚动条的隐藏或显示
            show: true,
            // 设置类型
            type: "slider",
            // 设置背景颜色
            backgroundColor: "rgb(19, 63, 100)",
            // 设置选中范围的填充颜色
            fillerColor: "rgb(16, 171, 198)",
            // 设置边框颜色
            borderColor: "rgb(19, 63, 100)",
            // 是否显示detail，即拖拽时候显示详细数值信息
            showDetail: false,
            // 数据窗口范围的起始数值
            startValue: 0,
            // 数据窗口范围的结束数值（一页显示多少条数据）
            endValue: 5,
            // 控制哪个轴，如果是number表示控制一个轴，
            // 如果是Array表示控制多个轴。此处控制第二根轴
            yAxisIndex: [0, 1],
            // empty：当前数据窗口外的数据，被设置为空。
            // 即不会影响其他轴的数据范围
            filterMode: "empty",
            // 滚动条高度
            width: 8,
            // 滚动条显示位置
            height: "80%",
            // 距离右边
            right: 3,
            // 控制手柄的尺寸
            handleSize: 0,
            // 是否锁定选择区域（或叫做数据窗口）的大小
            zoomLoxk: true,
            // 组件离容器上侧的距离
            // 如果top的值为'top', 'middle', 'bottom'，组件会根据相应的位置自动对齐
            top: "middle",
          },
          {
            // 没有下面这块的话，只能拖动滚动条，
            // 鼠标滚轮在区域内不能控制外部滚动条
            type: "inside",
            // 控制哪个轴，如果是number表示控制一个轴，
            // 如果是Array表示控制多个轴。此处控制第二根轴
            yAxisIndex: [0, 1],
            // 滚轮是否触发缩放
            zoomOnMouseWheel: false,
            // 鼠标移动能否触发平移
            moveOnMouseMove: true,
            // 鼠标滚轮能否触发平移
            moveOnMouseWheel: true,
          },
        ],
        series: [
          {
            //内
            type: "bar",
            barWidth: 6,
            barGap: 0.5,
            name: "社区数量",
            label: {
              show: false,
              position: "right",
              textStyle: {
                color: "#fff",
                fontSize: 16,
                padding: [0, 10],
                rich: {
                  a: {
                    color: "#fff",
                    fontSize: 36,
                  },
                },
              },
            },
            legendHoverLink: false,
            silent: true,
            itemStyle: {
              color: {
                type: "linear",
                x: 0,
                y: 0,
                x2: 1,
                y2: 0,
                colorStops: [
                  {
                    offset: 0,
                    color: "rgba(247,180,103,0)", // 0% 处的颜色
                  },
                  {
                    offset: 1,
                    color: "#F7B467", // 100% 处的颜色
                  },
                ],
                globalCoord: false, // 缺省为 false
              }, //底色
            },
            data: wzArr,
            zlevel: 13,
          },
          {
            //内2
            type: "bar",
            barWidth: 6,
            name: "网格数量",
            legendHoverLink: false,
            silent: true,
            label: {
              show: false,
              position: "right",
              textStyle: {
                color: "#fff",
                padding: [0, 10],
                fontSize: 16,
                rich: {
                  a: {
                    color: "#fff",
                    fontSize: 36,
                  },
                },
              },
            },
            itemStyle: {
              color: {
                type: "linear",
                x: 0,
                y: 0,
                x2: 1,
                y2: 0,
                colorStops: [
                  {
                    offset: 0,
                    color: "rgba(0,163,255,0)", // 0% 处的颜色
                  },
                  {
                    offset: 1,
                    color: "#00A3FF", // 100% 处的颜色
                  },
                ],
                globalCoord: false, // 缺省为 false
              }, //底色
            },
            data: gzhArr,
            zlevel: 11,
          },
          // {
          //   data: [200, 200, 200, 200, 200],
          //   type: "custom",
          //   xAxisIndex: 0,
          //   barGap: "-100%",
          //   silent: true,
          //   barWidth: 20,
          //   itemStyle: {
          //     normal: {
          //       color: "rgba(255,255,255,0.1)",
          //     },
          //   },
          //   zlevel: 9,
          // },
        ],
      };
      this.leftCenterOneList = option;
    },
    optionsListDataTwo(dataList) {
      let dateArr = dataList.map((item) => item.typeName);
      let completeArr = dataList.map((item) => item.completeCount);
      let shangbaoArr = dataList.map((item) => item.shangbaoCount);
      let allArr = dataList.map((item) => item.allCount);
      let option = {
        tooltip: {
          trigger: "axis",
          axisPointer: {
            // 坐标轴指示器，坐标轴触发有效
            type: "shadow", // 默认为直线，可选为：'line' | 'shadow'
          },
          backgroundColor: "rgba(3,9,24,0.7)",
          borderColor: "rgba(3,9,24,0.7)",
          textStyle: {
            color: "#fff",
          },
          formatter: function (param) {
            let res = param[0].name + "<br>";
            for (let j = 0; j < param.length; j++) {
              // 渐变色导致提示框中颜色消失,额外定义
              let marker = `<span style="display:inline-block;margin-right:5px;border-radius:50%;width:10px;height:10px;background-color:${param[j].color.colorStops[1].color};"></span>`;
              res += marker + param[j].seriesName + ": " + param[j].value + "<br>";
            }
            return res;
          },
        },
        grid: {
          left: "6%",
          right: "2%",
          top: "12%",
          bottom: "4%",
          containLabel: true,
        },
        legend: {
          data: ["巡查记录数", "问题上报数", "总任务数"],
          right: 10,
          textStyle: {
            color: "#E4F2FF",
            fontSize: 16,
          },
          itemWidth: 14,
          itemHeight: 7,
          // itemGap: 35
        },
        xAxis: {
          type: "category",
          data: dateArr,
          axisLine: {
            lineStyle: {
              color: "#8c9493",
            },
          },
          axisLabel: {
            // interval: 0,
            // rotate: 40,
            textStyle: {
              fontSize: 15,
              color: "#ADC2D3",
            },
            interval: 0,
            rotate: 40,
            //多出字可以省略显示成点
            formatter: function (params) {
              var index = 4; //字数为6个超出就显示成点
              var newstr = "";
              for (var i = 0; i < params.length; i += index) {
                var tmp = params.substring(i, i + index);
                newstr += tmp + "";
              }
              if (newstr.length > 4) return newstr.substring(0, 4) + "...";
              else return "\n" + newstr;
            },
          },
        },

        yAxis: {
          name: "单位：个",
          nameTextStyle: {
            color: "#ADC2D3",
            fontSize: 15,
          },
          type: "value",
          // max: "150",
          axisLine: {
            show: false,
            lineStyle: {
              color: "#8c9493",
            },
          },
          splitLine: {
            show: true,
            lineStyle: {
              color: "rgba(172, 206, 234, 0.2)",
              type: "dashed",
            },
          },
          axisLabel: {
            textStyle: {
              fontSize: 16,
              color: "#ADC2D3",
            },
          },
        },

        dataZoom: [
          {
            // 设置滚动条的隐藏与显示
            show: true,
            // 设置滚动条类型
            type: "slider",
            // 设置背景颜色
            backgroundColor: "rgb(19, 63, 100)",
            // 设置选中范围的填充颜色
            fillerColor: "rgb(16, 171, 198)",
            // 设置边框颜色
            borderColor: "rgb(19, 63, 100)",
            // 是否显示detail，即拖拽时候显示详细数值信息
            showDetail: false,
            // 数据窗口范围的起始数值
            startValue: 0,
            // 数据窗口范围的结束数值（一页显示多少条数据）
            endValue: 7,
            // empty：当前数据窗口外的数据，被设置为空。
            // 即不会影响其他轴的数据范围
            filterMode: "empty",
            // 设置滚动条宽度，相对于盒子宽度
            width: "90%",
            // 设置滚动条高度
            height: 8,
            // 设置滚动条显示位置
            left: "center",
            // 是否锁定选择区域（或叫做数据窗口）的大小
            zoomLoxk: true,
            // 控制手柄的尺寸
            handleSize: 0,
            // dataZoom-slider组件离容器下侧的距离
            bottom: 3,
          },
          {
            // 没有下面这块的话，只能拖动滚动条，
            // 鼠标滚轮在区域内不能控制外部滚动条
            type: "inside",
            // 滚轮是否触发缩放
            zoomOnMouseWheel: false,
            // 鼠标滚轮触发滚动
            moveOnMouseMove: true,
            moveOnMouseWheel: true,
          },
        ],
        series: [
          // {
          //   name: "巡查记录数",
          //   type: "bar",
          //   barWidth: 6,
          //   itemStyle: {
          //     color: {
          //       type: "linear",
          //       x: 0,
          //       y: 1,
          //       x2: 0,
          //       y2: 0,
          //       colorStops: [
          //         {
          //           offset: 0,
          //           color: "rgba(0,255,239,0)", // 0% 处的颜色
          //         },
          //         {
          //           offset: 1,
          //           color: "#00FFEF", // 100% 处的颜色
          //         },
          //       ],
          //       globalCoord: false, // 缺省为 false
          //     }, //底色
          //   },
          //   data: completeArr,
          // },
          {
            name: "问题上报数",
            type: "bar",
            barWidth: 6,
            itemStyle: {
              color: {
                type: "linear",
                x: 0,
                y: 1,
                x2: 0,
                y2: 0,
                colorStops: [
                  {
                    offset: 0,
                    color: "rgba(0,163,255,0)", // 0% 处的颜色
                  },
                  {
                    offset: 1,
                    color: "#00A3FF", // 100% 处的颜色
                  },
                ],
                globalCoord: false, // 缺省为 false
              }, //底色
            },
            data: shangbaoArr,
          },
          // {
          //   name: "总任务数",
          //   type: "bar",
          //   barWidth: 6,
          //   itemStyle: {
          //     color: {
          //       type: "linear",
          //       x: 0,
          //       y: 1,
          //       x2: 0,
          //       y2: 0,
          //       colorStops: [
          //         {
          //           offset: 0,
          //           color: "rgba(247,180,103,0)", // 0% 处的颜色
          //         },
          //         {
          //           offset: 1,
          //           color: "#F7B467", // 100% 处的颜色
          //         },
          //       ],
          //       globalCoord: false, // 缺省为 false
          //     }, //底色
          //   },
          //   data: allArr,
          // },
        ],
      };
      this.leftCenterTwoList = option;
    },
    optionsListDataThree(dataList) {
      const values = Object.values(dataList);
      let maxList = Math.max(...values);
      this.leftCenterFiveList = {
        legend: {
          show: false,
        },
        tooltip: {
          show: true,
          trigger: "item",
          backgroundColor: "rgba(3,9,24,0.7)",
          borderColor: "rgba(3,9,24,0.7)",
          textStyle: {
            color: "#fff",
          },
        },
        radar: {
          // shape: 'circle',
          name: {
            textStyle: {
              color: "#ADC2D3",
              fontSize: 16,
            },
          },
          indicator: [
            { name: "60-70岁", max: maxList },
            { name: "70-80岁", max: maxList },
            { name: "80-90岁", max: maxList },
            { name: "90岁以上", max: maxList },
          ],
        },
        series: [
          {
            name: "巡查人数",
            type: "radar",
            symbolSize: 0,
            itemStyle: {
              normal: {
                color: "#01E8FE",
                lineStyle: {
                  color: "#01E8FE",
                },
                shadowColor: "#01E8FE",
                shadowBlur: 10,
              },
            },
            areaStyle: {
              color: new echarts.graphic.RadialGradient(0.1, 0.6, 1, [
                {
                  color: "rgba(0,208,255,0.16)",
                  offset: 0,
                },
                {
                  color: "rgba(0,163,255,0.4)",
                  offset: 1,
                },
              ]),
            },
            data: [
              {
                value: values,
                name: "巡查人数",
              },
            ],
          },
        ],
      };
    },
    optionsListDataFour(dataList) {
      var xData = dataList.map(item => item.communityName);
      var data1 = dataList.map(item => item.ageFenbu.ageSixty);
      var data2 = dataList.map(item => item.ageFenbu.ageSeventy);
      var data3 = dataList.map(item => item.ageFenbu.ageEighty);
      var data4 = dataList.map(item => item.ageFenbu.ageNinty);
      console.log(data1, 9090)
      this.leftCenterFourList = {
        tooltip: {
          trigger: "axis",
          axisPointer: {
            type: "shadow",
          },
          backgroundColor: "rgba(3,9,24,0.7)",
          borderColor: "rgba(3,9,24,0.7)",
          textStyle: {
            color: "#fff",
          },
        },
        grid: {
          borderWidth: 0,
          top: 40,
          bottom: 60,
          textStyle: {
            color: "#fff",
          },
        },
        legend: {
          show: true,
          right: "2%",
          top: "4%",
          itemWidth: 14,
          itemHeight: 6,
          textStyle: {
            color: "#E4F2FF",
            fontSize: 16,
          },
          itemGap: 55,
          data: ["60-70岁", "70-80岁", "80-90岁", "90岁以上"],
        },

        calculable: true,
        xAxis: [
          {
            type: "category",
            nameTextStyle: {
              color: "#ADC2D3",
              fontSize: 15,
            },
            axisLine: {
              lineStyle: {
                color: "#ADC2D3",
                fontSize: 16,
              },
            },
            splitLine: {
              show: false,
            },
            axisTick: {
              show: false,
            },
            splitArea: {
              show: false,
            },
            axisLabel: {
              interval: 0,
            },
            data: xData,
          },
        ],
        yAxis: [
          {
            name: "单位：个",
            nameTextStyle: {
              color: "#ADC2D3",
              fontSize: 15,
            },
            type: "value",
            splitLine: {
              show: true,
              lineStyle: {
                color: "rgba(172, 206, 234, 0.2)",
                type: "dashed",
              },
            },
            axisLine: {
              lineStyle: {
                color: "#ADC2D3",
              },
            },
            axisTick: {
              show: false,
            },
            axisLabel: {
              interval: 0,
            },
            splitArea: {
              show: false,
            },
          },
        ],
        dataZoom: [
          {
            // 设置滚动条的隐藏与显示
            show: true,
            // 设置滚动条类型
            type: "slider",
            // 设置背景颜色
            backgroundColor: "rgb(19, 63, 100)",
            // 设置选中范围的填充颜色
            fillerColor: "rgb(16, 171, 198)",
            // 设置边框颜色
            borderColor: "rgb(19, 63, 100)",
            // 是否显示detail，即拖拽时候显示详细数值信息
            showDetail: false,
            // 数据窗口范围的起始数值
            startValue: 0,
            // 数据窗口范围的结束数值（一页显示多少条数据）
            endValue: 9,
            // empty：当前数据窗口外的数据，被设置为空。
            // 即不会影响其他轴的数据范围
            filterMode: "empty",
            // 设置滚动条宽度，相对于盒子宽度
            width: "90%",
            // 设置滚动条高度
            height: 8,
            // 设置滚动条显示位置
            left: "center",
            // 是否锁定选择区域（或叫做数据窗口）的大小
            zoomLoxk: true,
            // 控制手柄的尺寸
            handleSize: 0,
            // dataZoom-slider组件离容器下侧的距离
            bottom: 3,
          },
          {
            // 没有下面这块的话，只能拖动滚动条，
            // 鼠标滚轮在区域内不能控制外部滚动条
            type: "inside",
            // 滚轮是否触发缩放
            zoomOnMouseWheel: false,
            // 鼠标滚轮触发滚动
            moveOnMouseMove: true,
            moveOnMouseWheel: true,
          },
        ],
        series: [
          {
            name: "60-70岁",
            type: "bar",
            stack: "总量",
            barMaxWidth: 16,

            barGap: "5%",
            itemStyle: {
              normal: {
                color: "#00A3FF",
                // label: {
                //   show: true,
                //   textStyle: {
                //     color: "#fff",
                //   },
                //   position: "inside",
                //   formatter: function (p) {
                //     return p.value > 0 ? p.value : "";
                //   },
                // },
              },
            },
            data: data1,
          },

          {
            name: "70-80岁",
            type: "bar",
            stack: "总量",
            itemStyle: {
              normal: {
                color: "#01E8FE",
                barBorderRadius: 0,
                // label: {
                //   show: true,
                //   position: "inside",
                //   formatter: function (p) {
                //     return p.value > 0 ? p.value : "";
                //   },
                // },
              },
            },
            data: data2,
          },
          {
            name: "80-90岁",
            type: "bar",
            stack: "总量",
            itemStyle: {
              normal: {
                color: "#63DAA1",
                barBorderRadius: 0,
                // label: {
                //   show: true,
                //   position: "inside",
                //   formatter: function (p) {
                //     return p.value > 0 ? p.value : "";
                //   },
                // },
              },
            },
            data: data3,
          },
          {
            name: "90岁以上",
            type: "bar",
            stack: "总量",
            itemStyle: {
              normal: {
                color: "#F9A704",
                barBorderRadius: 0,
                // label: {
                //   show: true,
                //   position: "inside",
                //   formatter: function (p) {
                //     return p.value > 0 ? p.value : "";
                //   },
                // },
              },
            },
            data: data4,
          },
        ],
      };
    },
    optionsListDataFive(dataList) {
      this.totalAge = dataList.reduce((sum, current) => sum + Number(current.banliCount), 0);
      this.leftCenterThreeList = JSON.parse(JSON.stringify(dataList));
      this.leftCenterThreeList.forEach(item => {
        item.name = item.taskName
        item.value = Number(item.banliCount);
        item.itemStyle = {
            //颜色 紫色
            color: item.taskName == '日常巡查' ? "#00A3FF" : item.taskName == '专项任务' ? '#F7B467' : '#EB5A5A'
          }
      })
    },
    tabChangeRadio(val) {
      if (val == 'top') {
        this.getEventTaskLongPatrol(1);
        this.getEventTaskLongPatrol(2);
        this.getEventTaskLongPatrol(3);
      } else {
        this.getEventTaskOldPeople();
      }
    }
  },
};
</script>
<style scoped lang="less">
.left-center-list {
  width: 100%;
  height: 503px;
}
.flex-just {
  display: flex;
  justify-content: space-between;
}
.special-radio {
  position: absolute;
  margin-bottom: 0px !important;
  bottom: 0px;
  right: 10px;
  /deep/ .el-radio-button__orig-radio:checked + .el-radio-button__inner {
    background: linear-gradient(315deg, #006aff 0%, #00a3ff 100%);
    border: 1px solid rgba(0, 163, 255, 0.3);
    color: #ffffff;
  }
  /deep/ .el-radio-button__inner {
    background: rgba(4, 20, 50, 0.4);
    border: 1px solid rgba(0, 163, 255, 0.3);
    color: #00a3ff;
  }
}

.center-point {
  width: 518px;
  height: 400px;
  background: linear-gradient(0, rgba(0, 163, 255, 0) 0%, rgba(0, 163, 255, 0.1) 100%);
  border-radius: 4px;
  margin-top: 8px;
  padding-top: 6px;
}

.center-pointOne {
  width: 410px;
}
.center-pointFour {
  width: 948px;
}
</style>



// WEBPACK FOOTER //
// src/pages/patrolScreen/components/left/left-center.vue